"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductTypeEnum = void 0;
/** 产品三级形态 */
var ProductTypeEnum;
(function (ProductTypeEnum) {
    /** IaaS */
    ProductTypeEnum["IaaS"] = "IaaS";
    /** PaaS */
    ProductTypeEnum["PaaS"] = "PaaS";
    /** SaaS */
    ProductTypeEnum["SaaS"] = "SaaS";
    /** 软件 */
    ProductTypeEnum["Software"] = "Software";
    /** 医疗内容 */
    ProductTypeEnum["MedicalContent"] = "MedicalContent";
    /** 教育内容 */
    ProductTypeEnum["EducationalContent"] = "EducationalContent";
    /** 硬件-服务器 */
    ProductTypeEnum["HardwareServer"] = "HardwareServer";
    /** 硬件-网络设备 */
    ProductTypeEnum["HardwareNet"] = "HardwareNet";
    /** 硬件-其他 */
    ProductTypeEnum["HardwareOther"] = "HardwareOther";
    /** 定开服务 */
    ProductTypeEnum["ServiceCustomDevelopment"] = "ServiceCustomDevelopment";
    /** 运维服务 */
    ProductTypeEnum["ServiceOp"] = "ServiceOp";
    /** 交付服务 */
    ProductTypeEnum["ServiceImplementation"] = "ServiceImplementation";
    /** 维保服务 */
    ProductTypeEnum["ServiceProjectMaintenance"] = "ServiceProjectMaintenance";
    /** 咨询服务 */
    ProductTypeEnum["ServiceConsulting"] = "ServiceConsulting";
    /** 培训服务 */
    ProductTypeEnum["ServiceTraining"] = "ServiceTraining";
    /** 其他 */
    ProductTypeEnum["Others"] = "Others";
})(ProductTypeEnum || (exports.ProductTypeEnum = ProductTypeEnum = {}));
